
import { startsWithAlphanumeric, usedMoreThanAllowed } from './utils';
import { getSize } from '../iterable/getSize';

import { MAX_TITLE_LENGTH, ERRORS } from '../../constants/validations';
import { ETSY } from '../../constants/channels';

export function getTitleError({ channel, value }) {
  if (getSize(value) === 0) {
    return ERRORS.TITLE.REQUIRED;
  }

  if (MAX_TITLE_LENGTH.hasOwnProperty(channel) && getSize(value) > MAX_TITLE_LENGTH[channel]) {
    return ERRORS.TITLE.LENGTH_EXCEEDED[channel];
  }

  switch (channel) {
    case ETSY: {
      if (!startsWithAlphanumeric(value)) {
        return ERRORS.TITLE.ALPHANUMERIC_BEGIN;
      }

      if (/[^\p{L}\p{Nd}\p{P}\p{Sm}\p{Zs}™©®]/u.test(value)) {
        return ERRORS.TITLE.FORBIDDEN_CHARACTERS[channel];
      }

      if (usedMoreThanAllowed({ patterns: [/\b\p{Lu}{2,}\b/], number: 3, value })) {
        return ERRORS.TITLE.CAPITALIZED_WORDS_NUMBER_EXCEEDED;
      }

      if (usedMoreThanAllowed({ patterns: [/[&]/, /[%]/, /[:]/], number: 1, value })) {
        return ERRORS.TITLE.SPECIAL_CHARACTERS_NUMBER_EXCEEDED;
      }

      return false;
    }

    default: {
      return false;
    }
  }
}
